import React from "react";
import { useIntl } from "react-intl";

export const TextFormattedMessage = (props: any) => {
  const { formatMessage } = useIntl();

  return <div className={props.className} style={props.style}>{formatMessage({ id: props.id })}</div>;
};
 